import React from 'react'

const SvgScreenShareOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.168 6c.152-.45.406-.871.764-1.229L6.702 4H4a2 2 0 00-2 2v10a2 2 0 002 2h5l-1 2.004H7c-.667 0-1 .332-1 .998 0 .665.333.998 1 .998h10c.667 0 1-.333 1-.998 0-.666-.333-.998-1-.998h-1L15 18h5a2 2 0 002-2V6a2 2 0 00-2-2h-2.679l.747.749c.363.363.62.794.771 1.251H20v10H4V6h1.168zM11 18l-1 2.004h4L13 18h-2z'
    />
    <path d='M13.098 12.917V5.698l2.047 2.04a1.089 1.089 0 001.537 0 1.08 1.08 0 000-1.53l-3.902-3.89a1.088 1.088 0 00-1.537 0L7.318 6.23a1.08 1.08 0 000 1.532 1.089 1.089 0 001.537 0l2.07-2.064v7.219c0 .722.362 1.083 1.086 1.083.725 0 1.087-.36 1.087-1.083z' />
  </svg>
)

export default SvgScreenShareOutline
